export default "__VITE_ASSET__CVTFNA7x__"